/* Progressive enhancement of the private RFQ form. Shopify Forms remains the submission and CAPTCHA owner. */
(() => {
  const shell = document.querySelector('[data-sc-rfq]');
  if (!shell) return;
  let catalog;
  const bound = new WeakSet();
  function enhance(host) {
    const root = host.shadowRoot;
    if (!root || !catalog || bound.has(root)) return;
    const form = root.querySelector('form[data-testid="form"]');
    const input = root.getElementById('custom#product_model_required');
    const platformValue = root.getElementById('custom#platform-selector-value');
    if (!form || !input || !platformValue) return;
    bound.add(root);
    const platform = platformValue.closest('button').parentElement;
    const modelGroup = input.parentElement;
    // The stable field containers keep Shopify's own controlled inputs and event handlers.
    form.insertBefore(platform, modelGroup);
    const panel = document.createElement('div');
    panel.className = 'sc-model-picker';
    panel.innerHTML = '<label for="sc-model-choice">Choose a product model</label><select id="sc-model-choice" aria-describedby="sc-model-hint"></select><p id="sc-model-hint" role="status"></p>';
    form.insertBefore(panel, modelGroup);
    const select = panel.querySelector('select');
    const hint = panel.querySelector('p');
    const label = root.getElementById('label-custom#product_model_required');
    const style = document.createElement('style');
    style.textContent = '.sc-model-picker{display:grid;gap:8px;font:var(--forms-body-font);min-width:0}.sc-model-picker label{font-weight:600}.sc-model-picker select{font:inherit;width:100%;max-width:100%;padding:14px 10px;border:1px solid #bbb;border-radius:5px;background:#fff;color:#252525}.sc-model-picker select:focus-visible{outline:2px solid #a64028;outline-offset:2px}.sc-model-picker p{font:inherit;font-size:12px;line-height:1.5;margin:0;color:#555}';
    root.append(style);
    let previousPlatform;
    let lastSuggested = '';
    function write(value) {
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }
    function refresh() {
      const platformText = platformValue.textContent.trim();
      if (platformText === previousPlatform) return;
      const changed = previousPlatform !== undefined;
      previousPlatform = platformText;
      // Preserve visitor-entered custom text, clear a now-incompatible suggested model.
      if (changed && lastSuggested && input.value === lastSuggested) write('');
      lastSuggested = '';
      select.replaceChildren();
      const items = catalog[platformText] || [];
      select.add(new Option(platformText ? 'Select a model…' : 'Choose your platform above first', ''));
      for (const model of items) select.add(new Option(model, model));
      select.add(new Option('Other / model not listed — enter below', '__other'));
      select.add(new Option('Not sure — help me choose', '__unsure'));
      if (input.value) select.value = items.includes(input.value) ? input.value : '__other';
      hint.textContent = items.length ? `${items.length} models suggested for this selection. You can also type any model below. Exact configuration and compatibility will be confirmed with your quote.` : 'Choose a platform to see suggestions, or enter a model or describe your requirements below.';
      if (label) label.textContent = 'Requested model / your own model';
    }
    select.addEventListener('change', () => {
      if (select.value === '__other') { write(''); lastSuggested = ''; input.focus(); }
      else if (select.value === '__unsure') { write('Please recommend a suitable model'); lastSuggested = ''; }
      else if (select.value) { write(select.value); lastSuggested = select.value; }
    });
    input.addEventListener('input', () => {
      if (lastSuggested && input.value !== lastSuggested) { select.value = '__other'; lastSuggested = ''; }
    });
    new MutationObserver(refresh).observe(platformValue, { childList: true, subtree: true, characterData: true });
    refresh();
    const params = new URLSearchParams(location.search);
    const model = params.get('model'), sku = params.get('sku');
    const requested = model ? (sku ? '[' + sku.slice(0,120) + '] ' : '') + model : ''; 
    if (requested && !input.value) { write(requested.slice(0,200)); select.value = '__other'; }
  }
  function scan() { shell.querySelectorAll('shopify-forms-embed').forEach(enhance); }
  fetch(shell.dataset.modelsUrl).then(r => { if (!r.ok) throw new Error('Model list unavailable'); return r.json(); }).then(data => {
    catalog = data;
    scan();
    // App rendering and its shadow root are asynchronous; bounded retry avoids permanent polling.
    let attempts = 0;
    const timer = setInterval(() => { scan(); if (++attempts >= 120) clearInterval(timer); }, 500);
    new MutationObserver(scan).observe(shell, { childList: true, subtree: true });
  }).catch(() => { /* Keep the original working free-text form if enhancement cannot load. */ });
})();
